import type { FC } from 'react'

import type { ActionButtonProps } from '../commandActions/types'
import { EmployerAgreementNester } from './EmployerAgreementNester'

type Props = ActionButtonProps & {
  NestedCommand: FC<ActionButtonProps & { employerAgreementId: string }>
}

/**
 * Utility component to help nest commands that require an `employerAgreementId`.
 *
 * Mounts a single child when `employerAgreementId` is in the URL, and 0..N when not.
 * */
export const EmployerAgreementCommandNester = ({
  NestedCommand,
  ...props
}: Props) => (
  <EmployerAgreementNester NestedCommand={NestedCommand} nestedProps={props} />
)
